import styled, { css } from "styled-components";
import { colors, darkModeColors } from "../../consts";
import { FlexContainers } from "../index";

const NoBorder = css`
  border: none;
`;

export const Button = styled.button`
  width: 100%;
  height: 55px;

  background: ${(props) =>
    props?.secondary ? "transparent" : darkModeColors.RAISIN_100_ISABELLINE};

  border-radius: 100px;

  border: ${(props) => (props?.secondary ? "1px solid" : "none")};

  border-color: ${(props) =>
    props?.secondary ? (props?.theme?.darkMode ? colors.ISABELLINE : colors.RAISIN_100) : "unset"};
  outline: none;

  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: ${(props) =>
    props?.secondary ? darkModeColors.RAISIN_100_ISABELLINE : darkModeColors.ISABELLINE_RAISIN_100};

  ${(props) => props?.isRedText && `color: ${colors.ERROR}`};

  transition: 0.5s all;

  &:hover {
    opacity: 1;

    background: ${(props) =>
      props?.secondary
        ? darkModeColors.ISABELLINE_DARKER_RAISIN_80
        : darkModeColors.RAISIN_80_ISABELLINE_DARKER};
  }

  &:active {
    background: ${(props) =>
      props?.secondary ? darkModeColors.RAISIN_100_ISABELLINE : colors.TURQUOISE_100};
    color: ${darkModeColors.ISABELLINE_RAISIN_100} !important;

    border: "none";
  }

  &:disabled {
    background: ${(props) => (props?.secondary ? "transparent" : colors.RAISIN_50)};
    color: ${(props) => (props?.secondary ? darkModeColors.RAISIN_50_RAISIN_80 : colors.WHITE)};

    border-color: ${(props) => (props?.secondary ? darkModeColors.RAISIN_50_RAISIN_80 : "unset")};

    pointer-events: none;
    cursor: default;

    svg {
      path {
        fill: ${(props) => (props?.secondary ? darkModeColors.RAISIN_50_RAISIN_80 : colors.WHITE)};
      }
    }
  }

  a {
    color: inherit;
  }
`;

export const SmallButtonStyled = styled(Button)`
  padding: 0 40px;
  height: 48px;
  width: ${(props) => (props?.fullWidth ? "100%" : "fit-content")};
  border: ${(props) =>
    props?.secondaryBold
      ? `2px solid ${colors.RAISIN_100}`
      : props?.secondary
      ? "1px solid"
      : "none"};
  border-color: ${(props) =>
    props?.secondary ? (props?.theme?.darkMode ? colors.ISABELLINE : colors.RAISIN_100) : "unset"};

  ${(props) => props?.backgroundRed && `background: ${colors.ERROR}`};
  ${(props) => props?.isRedText && `color: ${colors.ERROR} !important`}
  ${(props) => props?.noBorder && NoBorder}

  &:hover {
    ${(props) => props?.backgroundRed && `background: ${colors.ERROR}; opacity: 0.7`};
  }

  &:active {
    ${(props) => props?.backgroundRed && `background: ${colors.ERROR}; opacity: 1`};
  }
`;

export const TextButton = styled.button`
  height: 40px;

  background: transparent;
  border: none;
  outline: none;

  cursor: pointer;

  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  color: ${(props) => (props?.color ? props.color : darkModeColors.RAISIN_100_WHITE)};

  transition: 0.5s all;

  text-decoration: ${(props) => (props?.underline ? "underline" : "none")};

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    color: ${colors.RAISIN_50};
    pointer-events: none;
    cursor: default;
  }
`;

export const IconButtonStyled = styled.button`
  background: none;
  border: none;
  outline: none;

  display: flex;
  cursor: pointer;

  transition: 0.5s all;

  width: fit-content;

  &:hover {
    opacity: 0.6;
  }

  img {
    height: inherit !important;
    min-height: unset !important;
    object-fit: contain;
  }

  &:disabled {
    opacity: 0.6;
    cursor: default !important;
    pointer-events: none;
  }

  ${(props) => props?.hasHoverCircle && HoverCircleIconButtonStyles}
  ${(props) => props?.isLarge && LargeIconButtonStyles}
`;

const HoverCircleIconButtonStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 36px;
  height: 36px;

  border-radius: 50%;

  &:hover {
    background: rgba(52, 48, 61, 0.1);
    opacity: 1;
  }
`;

const LargeIconButtonStyles = css`
  min-width: 48px;
  height: 48px;
`;

const CircleIconButtonSecondaryStyles = css`
  background: transparent;

  border: 1px solid;
  border-color: ${darkModeColors.RAISIN_100_WHITE};
`;

export const CircleIconButtonStyled = styled(IconButtonStyled)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  border-radius: 100%;

  background: ${darkModeColors.RAISIN_100_WHITE};

  ${(props) => props?.secondary && CircleIconButtonSecondaryStyles}
`;

export const DoubleButtonContainer = styled(FlexContainers.FlexRowStart)`
  position: relative;

  ${Button} {
    border-radius: 100px 0 0 100px;
    padding-left: 23px;
    padding-right: 13px;
    height: 48px;

    border-right: 1px solid rgba(246, 244, 240, 0.2);
  }
`;

export const DropdownButtonContainer = styled(FlexContainers.FlexRowStart)`
  position: relative;

  ${SmallButtonStyled} {
    padding-left: 24px;
    padding-right: 18px;

    svg {
      margin-top: 5px;
    }
  }
`;

export const ArrowButton = styled(Button)`
  border-radius: 0 100px 100px 0 !important;

  padding-left: 13px !important;
  padding-right: 13px !important;

  border-right: none !important;
`;
